import { Filter as GenericDashboardFilter } from '../shared-dtos-generic-dashboards-gz-console';
import { StringConditions } from '@nirvana/shared/dtos/types/shared/filters';

export class GenericDashboardsFiltersHelper {
  public static getCompanyIdFromSingleSelectCompanyFilter(filters: Array<GenericDashboardFilter>): string | undefined {
    const companyFilter = filters.find(filter => filter.company) as GenericDashboardFilter;
    if (!companyFilter) {
      throw new Error('Could not find any company filter.');
    }

    return (companyFilter.company as StringConditions).equals;
  }
}
